import AppButton, { AppButtonProps } from "./AppButton";

/** Cancel, Huỷ, Close, Back... */
const CancelButton = (props: Omit<AppButtonProps, "appVariant">) => (
  <AppButton appVariant="cancel" {...props} />
);

export default CancelButton;
